export { default } from "./DeprecationNotice";
